/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGASweatsSummarySectionQueryVariables = {|
  contestId: string,
  playerId?: ?string,
|};
export type PGASweatsSummarySectionQueryResponse = {|
  +cutSummaryForContest: ?{|
    +cutSummary: ?$ReadOnlyArray<?{|
      +madeCut: ?number,
      +numLineups: ?number,
    |}>,
    +totalNumLineups: ?number,
  |},
  +scoreSummaryForContest: ?{|
    +pointsSummary: ?$ReadOnlyArray<?{|
      +bucketMin: ?number,
      +numLineups: ?number,
    |}>,
    +totalNumLineups: ?number,
  |},
  +draftkingsContestById: ?{|
    +slate: {|
      +cutLine: ?number,
      +cutIsOfficial: boolean,
    |}
  |},
|};
export type PGASweatsSummarySectionQuery = {|
  variables: PGASweatsSummarySectionQueryVariables,
  response: PGASweatsSummarySectionQueryResponse,
|};
*/


/*
query PGASweatsSummarySectionQuery(
  $contestId: ID!
  $playerId: ID
) {
  cutSummaryForContest(contestId: $contestId, playerId: $playerId) {
    cutSummary {
      madeCut
      numLineups
    }
    totalNumLineups
  }
  scoreSummaryForContest(contestId: $contestId, playerId: $playerId) {
    pointsSummary {
      bucketMin
      numLineups
    }
    totalNumLineups
  }
  draftkingsContestById(contestId: $contestId) {
    slate {
      cutLine
      cutIsOfficial
      id
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contestId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "playerId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "contestId",
  "variableName": "contestId"
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "playerId",
    "variableName": "playerId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numLineups",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalNumLineups",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": (v2/*: any*/),
  "concreteType": "DraftKingsContestSummaryType",
  "kind": "LinkedField",
  "name": "cutSummaryForContest",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DraftKingsContestSummaryEntryType",
      "kind": "LinkedField",
      "name": "cutSummary",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "madeCut",
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": (v2/*: any*/),
  "concreteType": "DraftKingsContestPointsSummaryType",
  "kind": "LinkedField",
  "name": "scoreSummaryForContest",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DraftKingsContestPointsSummaryEntryType",
      "kind": "LinkedField",
      "name": "pointsSummary",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bucketMin",
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v7 = [
  (v1/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cutLine",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cutIsOfficial",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PGASweatsSummarySectionQuery",
    "selections": [
      (v5/*: any*/),
      (v6/*: any*/),
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "DraftKingsContestType",
        "kind": "LinkedField",
        "name": "draftkingsContestById",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SlateType",
            "kind": "LinkedField",
            "name": "slate",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PGASweatsSummarySectionQuery",
    "selections": [
      (v5/*: any*/),
      (v6/*: any*/),
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "DraftKingsContestType",
        "kind": "LinkedField",
        "name": "draftkingsContestById",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SlateType",
            "kind": "LinkedField",
            "name": "slate",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "620c41adc71fce9a553ebede872146d5",
    "id": null,
    "metadata": {},
    "name": "PGASweatsSummarySectionQuery",
    "operationKind": "query",
    "text": "query PGASweatsSummarySectionQuery(\n  $contestId: ID!\n  $playerId: ID\n) {\n  cutSummaryForContest(contestId: $contestId, playerId: $playerId) {\n    cutSummary {\n      madeCut\n      numLineups\n    }\n    totalNumLineups\n  }\n  scoreSummaryForContest(contestId: $contestId, playerId: $playerId) {\n    pointsSummary {\n      bucketMin\n      numLineups\n    }\n    totalNumLineups\n  }\n  draftkingsContestById(contestId: $contestId) {\n    slate {\n      cutLine\n      cutIsOfficial\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'db945e4e02b46ff755d3abd42922a027';

module.exports = node;
